// RoleBasedRoute.js
import { useContext } from "react";
import { Navigate } from "react-router-dom";
import { UserContext } from "../../UserContext";
const RoleBasedRoute = ({ allowedRoles, children }) => {
  const { roles, loading } = useContext(UserContext);
  if (loading) return <div>Loading...</div>; // ⏳ Wait until roles are loaded
  const isAuthorized =
    Array.isArray(roles) && roles.some((role) => allowedRoles.includes(role));
  return isAuthorized ? children : <Navigate to="/unauthorized" replace />;
};
export default RoleBasedRoute;